import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
// import { Badge } from '../ui/badge';
import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from '../ui/breadcrumbs';

export default function Breadcrumb({ items = [] }) {
  return (
    <ShadcnBreadcrumb className='p-4 mb-4'>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link className='text-lg' to='/'>
              Home
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {items.map((item, idx) => (
          <React.Fragment key={idx}>
            <BreadcrumbSeparator>
              <ChevronRight size={16} strokeWidth={1.5} className='w-4 h-4 ml-1.5' />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              {idx === items.length - 1 ? (
                <BreadcrumbPage>
                  <Link className='text-lg font-bold' to={item.link}>
                    {item.label}
                  </Link>
                </BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link className='text-lg' to={item.link}>
                    {item.label}
                  </Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </ShadcnBreadcrumb>
  );
}
